import { ESignProvider } from '@dealstack/shared/lib/generated';

/**
 * Whether this document signs through eID Easy. Keyed on the document's own provider: a document
 * with no provider recorded (e.g. wet ink) routed into the eID Easy flow is stranded there.
 */
export const isEidEasySigningDocument = (
	eSignProvider: ESignProvider | null | undefined
): boolean => eSignProvider === ESignProvider.EID_EASY;
